import { routes } from './routes.js';
import { getDefaultParam } from './utils/getDefaultParam.js';
import { getStore } from './utils/redux/store/getStore.js';
import { Router } from './utils/router/Router.js';

export const router = new Router(getStore);

const hooks = {
  before: doneCallback => {
    const done = (goToNext = true) => {
      doneCallback(goToNext);
    };

    const event = new CustomEvent('beforenav', { cancelable: true, detail: { done } });

    if (window.dispatchEvent(event)) {
      done();
    }
  }
};

router
  .params(getDefaultParam)
  .hooks(hooks)
  .on(routes);